import { React } from 'react';
import { LuRocket } from 'react-icons/lu';

const TeamCard = () => {
    return (
        <div className="card">
            <div className="card-body p-4">
                <div class="icon mb-3">
                    <LuRocket className="text-dark fs-3" />
                </div>
                <h3 className="card-title">PCA</h3>
                {/* <p className="card-subtitle mb-2 text-muted">Software Engineer</p> */}
                <p className="card-text">The Public Cloud Shared Services (PCSS) team is dedicated to delivering innovative, secure, and scalable cloud solutions. We streamline operations and enable organizations to thrive in a cloud-first world.</p>
            </div>
        </div>
    );
}

export default TeamCard;
